import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import RadioButtons from '.';
import breakpoints from '../Theme/breakpoints';

const RadioButtonsWrapper = styled.div`
  && {
    margin: 12px 0;

    .MuiFormGroup-root {
      @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        justify-content: flex-end;
      }
    }

    .MuiButtonBase-root {
      padding: 10px;
    }

    .MuiFormControlLabel-root {
      margin: 0 0 0 6px;
      height: 3rem;
    }

    .MuiFormControlLabel-label {
      margin: 0;
    }
  }
`;

const searchRadioButtonsPropertyTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

type SearchRadioButtonsProperties = InferProps<
  typeof searchRadioButtonsPropertyTypes
>;

const SearchRadioButtons = (properties: SearchRadioButtonsProperties) => (
  <RadioButtonsWrapper>
    <RadioButtons {...properties} />
  </RadioButtonsWrapper>
);

SearchRadioButtons.propTypes = searchRadioButtonsPropertyTypes;

export default SearchRadioButtons;
